module.exports = __webpack_public_path__ + "img/7.2c672ff4.webp";